import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Beside the name of an action whose manifest says it is AI (`ai`: any
 * machine-learned model). Every other action carries no mark. Ink on the
 * shell's page colour, so it is a dark pill on the light pages and a light
 * one in the dark viewer; the sparkle is the same one the AI tab wears.
 */
export function AiBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold leading-4 tracking-wide',
        'bg-[color:var(--tr-ink,var(--primary))] text-[color:var(--tr-page,var(--primary-foreground))]',
        className,
      )}
    >
      <Sparkles className="h-3 w-3" aria-hidden />
      AI
    </span>
  );
}
